module.exports = __webpack_public_path__ + "img/tree-fire-flame-01-b.b66a2b37.png";